module.exports = __webpack_public_path__ + "static/img/sharetxt_bg.c8914818.png";